import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetIntervalTypes } from '@webapp/models/enums/BudgetInterval'
import { type BudgetIntervalOption } from '../BudgetIntervalSelect'
import messages from '../messages'

export const useBudgetIntervalOptions = () => {
  const intl = useProcurifyIntl()

  const intervalOptions: BudgetIntervalOption[] = [
    {
      label: intl.formatMessage(messages.entireDateRangeOption),
      value: BudgetIntervalTypes.ENTIRE_DATE_RANGE,
    },
    {
      label: intl.formatMessage(messages.monthlyOption),
      value: BudgetIntervalTypes.MONTHLY,
    },
    {
      label: intl.formatMessage(messages.quarterlyOption),
      value: BudgetIntervalTypes.QUARTERLY,
    },
    {
      label: intl.formatMessage(messages.yearlyOption),
      value: BudgetIntervalTypes.YEARLY,
    },
  ]

  return intervalOptions
}
